import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Button,
  Card,
  Col,
  FlexView,
  Row,
  Text,
  TextInput,
  PasswordInput,
} from '@cuemath/comps';

import { getGoogleLoginURL } from 'constants/api';

const Wrapper = styled(FlexView)`
  height: 100vh;
  background-color: rgb(128, 128, 128);
  background-size: ${Math.ceil((window.screen.availWidth * 14) / 10)}px
    ${Math.ceil((window.screen.availWidth * 14) / 10)}px;
`;
const Link = styled.a`
  display: block;
  background: linear-gradient(56.99deg, #0177ff 0%, #1f48d7 100%);
  border-radius: 5px;
  padding: 8px;
  text-decoration: none;
`;
const LoginCard = styled(Card)`
  width: 408px;
`;
const LoginButton = styled(Button)`
  min-width: 108px;
`;

const MESSAGE = 'Required';

export default class Login extends PureComponent {
  static defaultProps = {
    error: null,
  };

  static propTypes = {
    error: PropTypes.shape({
      message: PropTypes.string,
    }),
    onSubmit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      form: {
        username: '',
        password: '',
      },
      renderErrors: false,
    };

    this.onUsernameChange = this.onChange.bind(this, 'username');
    this.onPasswordChange = this.onChange.bind(this, 'password');
  }

  onChange = (key, value) => {
    this.setState(({ form }) => ({
      form: {
        ...form,
        [key]: value,
      },
    }));
  };

  onSubmit = e => {
    const {
      form: { username, password },
    } = this.state;
    const { onSubmit } = this.props;

    e.preventDefault();

    if (username && password) {
      onSubmit(username, password);
    } else {
      this.setState({
        renderErrors: true,
      });
    }
  };

  render() {
    const { form, renderErrors } = this.state;
    const { error } = this.props;

    return (
      <Wrapper alignItems="center" justifyContent="center">
        <LoginCard gutter gap>
          <FlexView>
            <Row justifyContent="center">
              <Link href={getGoogleLoginURL()}>
                <Text align="center" color="white" weight="bold">
                  Login With Google
                </Text>
              </Link>
            </Row>
            <br margin="20px" />
            <Row justifyContent="center" style={{ fontWeight: 'bold' }}>
              OR
            </Row>
            <br />
            <form onSubmit={this.onSubmit}>
              {error && error.message && (
                <React.Fragment>
                  <Text type="negative" size="small" weight="semibold">
                    {error.message}
                  </Text>
                  <br />
                </React.Fragment>
              )}
              <TextInput
                label="Username"
                value={form.username}
                autoComplete="username"
                error={renderErrors && !form.username ? MESSAGE : null}
                onChange={this.onUsernameChange}
              />
              <br />
              <br />
              <PasswordInput
                label="Password"
                value={form.password}
                autoComplete="current-password"
                error={renderErrors && !form.password ? MESSAGE : null}
                onChange={this.onPasswordChange}
                toggleEnabled
              />
              <br />
              <Row justifyContent="center">
                <Col>
                  <LoginButton type="submit" label="Log in" />
                </Col>
              </Row>
            </form>
          </FlexView>
        </LoginCard>
      </Wrapper>
    );
  }
}
